import Vue from 'vue'
import Router from 'vue-router'

// Routes
import HomeRoutes from '@/router/home.js'
import AdminRoutes from '@/router/admin.js'
import LauncherRoutes from '@/router/launcher.js'
import DetailRoutes from '@/router/detail.js'
import DashboardRoutes from '@/router/dashboard.js'
import StoreRoutes from '@/router/store.js'


Vue.use(Router)

const routes = [].concat(
  HomeRoutes,
  AdminRoutes,
  LauncherRoutes,
  DetailRoutes,
  DashboardRoutes,
  StoreRoutes
)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL || '/',
  routes: routes
})
